import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { ClinicForm } from '../../../components/ClinicForm';
import styles from './CreateClinic.module.scss';
const CreateClinic = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { submitClinicInfo } = useAuth();
    const handleSubmit = async (formData) => {
        const uid = searchParams.get('uid');
        if (!uid) {
            throw new Error('Missing UID.');
        }
        const result = await submitClinicInfo(formData, uid);
        if (result.success) {
            navigate('/account/clinicSuccess');
        }
        else {
            throw new Error(result.message || 'Failed to submit clinic information');
        }
    };
    return (_jsx("div", { className: styles.createAccountWrapper, children: _jsx(ClinicForm, { mode: "create", onSubmit: handleSubmit, showBillingAddress: true, showTermsAndConditions: true }) }));
};
export default CreateClinic;
